import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from "@/views/Login/Login.vue";
import { hasQueryParams } from "@/helpers/helpers";

Vue.use(VueRouter);

const routes = [{
    path: '/',
    name: 'Home',
    redirect: '/app'    
},{
    path: '/entrar',
    name: 'Login',
    component: Login
}, {
    path: '/arquivos',
    name: 'Files',
    component: () => import('@/views/Files/Files.vue')
}, {
    path: '/perfil',
    name: 'Profile',
    component: () => import('@/views/Profile/Profile.vue')
}, {
    path: '/mudar-senha',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword/ResetPassword.vue')
}, {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: () => import('@/views/Unsubscribe/Unsubscribe.vue')
}, {
    path: '/redirect',
    name: 'Redirect',
    component: () => import('@/views/Redirect/Redirect.vue')
}, {
    path: '/site',
    name: 'site',
    component: () => import('@/views/Site/Site.vue')
}];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
    
});


router.beforeEach((to, from, next)=> {
    if (!hasQueryParams(to) && hasQueryParams(from) && to.name) {
        next({ ...to, ...{ name: to.name, query: from.query } });
    } else {
        next()
    }
});


export default router
